<template>
  <paginate
    :value="value"
    :class="classes"
    :page-count="pageCount"
    :click-handler="changePage"
    :prev-text="'base.back' | translate"
    prev-class="pagination__item--first"
    :next-text="'base.forward' | translate"
    next-class="pagination__item--last"
    container-class="pagination"
    page-class="pagination__item"
    active-class="pagination__item--active"
    disabled-class="pagination__item--disabled"
    page-link-class="pagination__link">
  </paginate>
</template>

<script>
export default {
  name: 'UiPagination',

  props: {
    value: Number,
    pageCount: Number,
    offsetNone: Boolean
  },

  methods: {
    changePage (page) {
      this.$emit('input', page)
      this.$emit('page-change', page)
    }
  },

  computed: {
    classes () {
      return {
        'pagination--offset-none': this.offsetNone
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/sass/abstracts/_variables.scss';

  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    margin-top: 2rem;

  &--position-absolute {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -3rem;
  }

  &--offset-none {
    margin-top: 0;
  }

  &__item {
    margin: 0 .5rem;

    &--first {
      padding-right: 1rem;
    }

    &--last {
      padding-left: 1rem;
    }
    
    &--active {
      border-radius: .5rem;
      background: $color-primary;

      .pagination__link {
        color: $color-white;
      }
    }

    &--disabled {

      a {
        color: $color-gray;
      }
    }
  }

  &__link {
    display: inline-flex;
    padding: .5rem 1rem;
    user-select: none;
    outline: none;
    border-radius: .5rem;
    transition: .3s ease-in-out;

    &:hover {
      background: rgba($color-primary, .3);
    }
  }
}
</style>